import React from 'react'
import SingleAssetItem from '../Market/SingleAssetItem'

const DiscoverPage = () => {
    return (
        <div className="DiscoverPage Marketui">
            <ul className="assetItems">
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
            </ul>
        </div>
    )
}

export default DiscoverPage
